import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Purchases } from '@revenuecat/purchases-capacitor';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevenueCatService {

  constructor(private platform: Platform) { }

  /**
   * Inizializza RevenueCat
   */
  public async init(){
    if (this.platform.is('ios')) {
      await this.configureIOS();
    }
    if (this.platform.is('android')) {
      await this.configureAndroid();
    }
  }

  private async configureIOS(){
    await Purchases.configure({apiKey: environment.apiKeyIOS});
  }

  private async configureAndroid(){
    await Purchases.configure({apiKey: environment.apiKeyAndroid});
  }
}
